import { combineReducers } from 'redux';
import compose, * as fromCompose from './compose';
import execute, * as fromExecute from './execute';

export default combineReducers({
  execute,
  compose,
});

export const getExecutionEvents = (state) => fromExecute.getEvents(state.execute);

export const getChartOptions = (state) => fromExecute.getChartOptions(state.execute);

export const getExecuteTime = (state) => fromExecute.getExecuteTime(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);

export const getSessions = (state) => fromExecute.getSessions(state.execute);

export const getAvgSessionLength = (state) => fromExecute.getAvgSessionLength(state.execute);

export const getUniqueUsers = (state) => fromExecute.getUniqueUsers(state.execute);

export const getQueryType = (state) => fromCompose.getQueryType(state.compose);

export const getGroupColumn = (state) => fromCompose.getGroupColumn(state.compose);

export const getSplitColumn = (state) => fromCompose.getSplitColumn(state.compose);
